import { Pipe, PipeTransform } from '@angular/core';
import { APIsettings } from '../../app/app.config';
import * as moment from 'moment-timezone';
@Pipe({
  name: 'userDate'
})

export class UserDatePipe implements PipeTransform {

  prefs = null;
  flagReverse = 'reverse';

  constructor(
    private apiSettings: APIsettings,
  ) {
    this.prefs = JSON.parse(localStorage.getItem('currentUser')).user.prefs;
  }

  transform(value: string, format = 'date, time'): any {
    console.log('START ****** Start Value: ', value, ' | format: ', format);

    let stringValue = '';
    // Get user preferenced time zone, if not get their local zone.
    const prefZone = this.prefs.time_zone ? this.prefs.time_zone : moment.tz.guess();

    // If a format is prefered then use it, if not use a default.
    const prefDateFormat = this.prefs.date_format ? this.prefs.date_format : 'DD/MM/YY';
    const prefTimeFormat = this.prefs.time_format ? (this.prefs.time_format.includes('12') ? 'hh:mma' : 'HH:mm') : 'HH:mm';

    // Manage formatting in order for moment to understand what we want.
    // if no custom format is given then use a default.
    let stringDate = format.replace('no-offset', '');
    stringDate = stringDate.replace('date', prefDateFormat);
    stringDate = stringDate.replace('time', prefTimeFormat + ' z');

    // If we have any api detials wanted.
    if (format.includes('api')) {
      stringDate = stringDate.replace('dateApi', this.apiSettings.apiDateFormat);
      stringDate = stringDate.replace('dateTimeApi', this.apiSettings.apiDateTimeFormat);
    }


    // Take the given time, off set this for our timezone and then format the UTC.
    const localMoment = moment(value);
    console.log('localMoment: ', localMoment);
    if (format.includes('utc')) {
      // stringValue = DateTime.fromISO(value, { zone: 'utc' }).toFormat(format);
      stringValue = moment.utc(value).format(stringDate);
    }
    else if (!format.includes('no-offset')) {
      // stringValue = moment.tz(value, prefZone).format(stringDate);
      stringValue = moment.utc(value).tz(prefZone).format(stringDate); // This should take UTC time and add timezone offset

      const _momentNow = moment.utc('2025-10-07 23:59');
      const _momentNowTz = _momentNow.tz(prefZone);
      console.log('_momentNow: ', _momentNow)
      console.log('Local moment now: ', _momentNowTz);
      console.log('Local moment now format: ', _momentNowTz.format());
    } else {
      stringValue = localMoment
        .format(stringDate);
    }

    // console.log('stringValue: ', stringValue, '| prefZone: ', prefZone);
    return stringValue;
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_pipes/user-date.pipe.ts